// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3lHd6","question":"styles_question__WFvXZ","description":"styles_description__3-sgH"};